import React  from "react";
import { Box, Typography} from "@mui/material";

import {useTranslation} from "react-i18next";
import ovalOverlay from "./img/gradient_frame_transparent.png";

import faceScanIcon from "./img/face_scanning_icon.png";

import { useStyles } from "./FaceScanner"

const LoadingModelPage = () => {
    const {classes} = useStyles();

    const { t } = useTranslation("pages.MaskSelectorTool.FaceScanner");

    // Localization strings
    const instructions = t("instructions");
    const loading = t("loading");

    return (
        <>
            <Box className={classes.overheadMessageBox}>
                <Typography>{instructions}</Typography>
            </Box>

            <div className="container">

                <Box className={classes.portrait}>
                    <img src={ovalOverlay} width="100%" />


                    <Box className={classes.scanningBox}>
                        <Typography className={classes.scanning}>{loading}</Typography>
                    </Box>
                    <Box className={classes.scanIconBox}>
                        <img src={faceScanIcon} />
                    </Box>

                </Box>
            </div>
        </>
    );

}

export default LoadingModelPage;